import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-lg-3" }
const _hoisted_3 = { class: "px-3 p-lg-0 ps-lg-3" }
const _hoisted_4 = ["src", "alt", "title"]
const _hoisted_5 = ["src", "alt", "title"]
const _hoisted_6 = { class: "col-12 col-lg-9" }
const _hoisted_7 = { class: "panel-text p-3 p-lg-0 pe-lg-3" }
const _hoisted_8 = { class: "my-4" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 1,
  class: "col-12"
}
const _hoisted_12 = { class: "panel-text" }
const _hoisted_13 = { class: "my-4" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["panel", { 'panel-img': _ctx.banner.img }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.banner.img || _ctx.banner.imgB)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.banner.img)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "w-100 mb-3",
                      src: _ctx.banner.img,
                      alt: _ctx.banner.title,
                      title: _ctx.banner.title
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                (_ctx.banner.imgB)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "w-100",
                      src: _ctx.banner.imgB,
                      alt: _ctx.banner.title,
                      title: _ctx.banner.title
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, _toDisplayString(_ctx.catalogName), 1),
                _createElementVNode("h2", null, _toDisplayString(_ctx.banner.title), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "description mb",
                    innerHTML: _ctx.banner.description
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    class: "btn btn-primary",
                    href: _ctx.contactURL
                  }, "Contact Us", 8, _hoisted_10)
                ])
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, _toDisplayString(_ctx.catalogName), 1),
              _createElementVNode("h2", null, _toDisplayString(_ctx.banner.title), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: "description mb",
                  innerHTML: _ctx.banner.description
                }, null, 8, _hoisted_14)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  class: "btn btn-primary",
                  href: _ctx.contactURL
                }, "Contact Us", 8, _hoisted_15)
              ])
            ])
          ]))
    ])
  ], 2))
}